import * as React from 'react'

export const StageLibrary = props => (
  <svg
    width={73}
    height={80}
    viewBox="0 0 73 80"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g filter="url(#filter0_d_81_12629)">
      <path
        d="M33.8674 8.03856C35.6165 7.01291 37.7835 7.01291 39.5326 8.03856L61.6454 21.0049C63.3597 22.0101 64.4128 23.8484 64.4128 25.8356V51.9195C64.4128 53.9068 63.3597 55.7451 61.6454 56.7503L39.5326 69.7166C37.7835 70.7423 35.6165 70.7423 33.8674 69.7166L11.7546 56.7503C10.0403 55.7451 8.9872 53.9068 8.9872 51.9195V25.8356C8.9872 23.8484 10.0403 22.0101 11.7546 21.0049L33.8674 8.03856Z"
        fill="#FBFBFB"
      />
      <path
        d="M33.8901 14.9968C35.6278 13.9888 37.7722 13.9888 39.5099 14.9968L56.2006 24.6785C57.9277 25.6803 58.9907 27.5259 58.9907 29.5225V48.9316C58.9907 50.9282 57.9277 52.7738 56.2006 53.7756L39.5099 63.4574C37.7722 64.4653 35.6278 64.4653 33.8901 63.4574L17.1994 53.7756C15.4723 52.7738 14.4093 50.9282 14.4093 48.9316V29.5225C14.4093 27.5259 15.4723 25.6803 17.1994 24.6785L33.8901 14.9968Z"
        fill="#9796CE"
      />
      <g filter="url(#filter1_d_81_12629)">
        <rect
          x="20.7"
          y="23.8507"
          width="9.04348"
          height="25.8602"
          rx="1.57173"
          fill="#DB5AC3"
        />
      </g>
      <rect
        x="24.1783"
        y="29.4421"
        width="2.78261"
        height="17.4731"
        rx="0.785865"
        fill="#C53AA3"
      />
      <g filter="url(#filter2_d_81_12629)">
        <rect
          x="22.0913"
          y="55.3023"
          width="3.49462"
          height="29.2174"
          rx="0.785865"
          transform="rotate(-90 22.0913 55.3023)"
          fill="#A86F3D"
        />
      </g>
      <g filter="url(#filter3_d_81_12629)">
        <rect
          x="44.3522"
          y="23.8507"
          width="7.65217"
          height="25.8602"
          rx="1.1788"
          fill="#4A2274"
        />
      </g>
      <g filter="url(#filter4_d_81_12629)">
        <rect
          width="7.38848"
          height="24.879"
          rx="1.1788"
          transform="matrix(0.965621 -0.259955 0.257688 0.966228 29.7435 25.7714)"
          fill="#922AE2"
        />
      </g>
      <rect
        x="47.1348"
        y="30.1411"
        width="2.78261"
        height="17.4731"
        rx="0.785865"
        fill="#2E124C"
      />
      <rect
        x="44.3522"
        y="28.0443"
        width="7.65217"
        height="1.39785"
        fill="#F0BD16"
      />
      <rect
        width="7.45413"
        height="1.42529"
        transform="matrix(0.965621 -0.259955 0.257688 0.966228 35.0663 45.7538)"
        fill="#F0BD16"
      />
      <rect
        x="20.7"
        y="25.9475"
        width="9.04348"
        height="2.09677"
        fill="#F0BD16"
      />
    </g>
    <defs>
      <filter
        id="filter0_d_81_12629"
        x="-3.29999"
        y="-0.622406"
        width="80"
        height="81"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1" />
        <feGaussianBlur stdDeviation="4" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.197115 0 0 0 0 0.00379068 0 0 0 0 0.119786 0 0 0 0.3 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_81_12629"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_81_12629"
          result="shape"
        />
      </filter>
      <filter
        id="filter1_d_81_12629"
        x="20.7"
        y="23.8507"
        width="9.04349"
        height="27.039"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.1788" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_81_12629"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_81_12629"
          result="shape"
        />
      </filter>
      <filter
        id="filter2_d_81_12629"
        x="22.0913"
        y="51.8077"
        width="29.2174"
        height="4.67343"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.1788" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_81_12629"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_81_12629"
          result="shape"
        />
      </filter>
      <filter
        id="filter3_d_81_12629"
        x="44.3522"
        y="23.8507"
        width="7.65216"
        height="27.039"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.1788" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_81_12629"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_81_12629"
          result="shape"
        />
      </filter>
      <filter
        id="filter4_d_81_12629"
        x="30.0071"
        y="24.1164"
        width="13.0182"
        height="26.607"
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity="0" result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy="1.1788" />
        <feComposite in2="hardAlpha" operator="out" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_81_12629"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_81_12629"
          result="shape"
        />
      </filter>
    </defs>
  </svg>
)
